import type { ReactNode } from 'react';
import { Container, Stack, Text, Title } from '@mantine/core';

interface StatusScreenProps {
  readonly title: string;
  readonly message: string;
  /** Что делать дальше: кнопки и ссылки. */
  readonly children?: ReactNode;
}

// Экран вместо страницы: 404 и непредвиденная ошибка. Заголовок, что случилось и следующий шаг.
export default function StatusScreen({ title, message, children }: StatusScreenProps) {
  return (
    <Container size="sm" py={64}>
      <Stack align="center" gap="md" ta="center">
        <Title order={1}>{title}</Title>
        <Text c="gray.7">{message}</Text>
        {children}
      </Stack>
    </Container>
  );
}
